import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LabeledFormControl, assert } from 'ats-ui-lib';
import {
  ComplementaryFormAnswer,
  JobApplicationComplementaryFormQuestionTypeEnum,
} from './job-application-complementary-form.model';

export class FactoryFormMultipleChoiceQuestion {
  static create(
    fb: UntypedFormBuilder,
    id: string,
    options: ComplementaryFormAnswer[],
    label: string,
    required: boolean,
    sequence: number,
  ): UntypedFormGroup {
    assert(fb);

    return fb.group({
      id: [id],
      label: [label],
      type: [JobApplicationComplementaryFormQuestionTypeEnum.MultipleChoice],
      required: [required],
      answerId: new LabeledFormControl(`${sequence}`, null, required ? [Validators.required] : []),
      options: fb.array(
        options.map((answer) =>
          fb.group({
            id: [answer.id],
            label: [answer.label],
          }),
        ),
      ),
    });
  }
}
